import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { TuningServices } from "./TuningServices";
import { GcfWidget } from "./GcfWidget";
import { useT } from "@/lib/i18n";

const TXT = {
  no: { more: "Stage 1, Stage 2 og ECU/TCU – les mer og se priser", h2a: "Mer trøkk.", h2b: "Samme motor.", p: "Chiptuning og Stage 1 tuning i Stavanger: vi leser ut originalprogramvaren, justerer ladetrykk, innsprøytning og tenning, og skriver tilbake en Stage 1-fil tilpasset din bil. Originalfilen tas alltid vare på. Bruk Stage 1-kalkulatoren under for å se veiledende effekt og dreiemoment for din bil." },
  en: { more: "Stage 1, Stage 2 and ECU/TCU – read more and see prices", h2a: "More punch.", h2b: "Same engine.", p: "Chiptuning and Stage 1 tuning in Stavanger: we read out the original software, adjust boost pressure, injection and ignition, and write back a Stage 1 file tailored to your car. The original file is always kept. Use the Stage 1 calculator below to see indicative power and torque for your car." },
};

export const Chiptuning = () => {
  const t = useT(TXT);
  return (
  <section id="tuning" data-testid="dyno-section" className="relative overflow-hidden border-y border-white/10 bg-[var(--surface)]">
    <img src="/img/engine.webp" alt="" loading="lazy" className="absolute inset-y-0 right-0 hidden h-full w-1/2 object-cover opacity-20 grayscale lg:block [mask-image:linear-gradient(to_left,black,transparent)]" />
    <div className="relative mx-auto grid max-w-7xl gap-10 px-5 pb-12 pt-24 sm:px-8 md:pt-32 lg:grid-cols-2 lg:items-end">
      <Reveal>
        <Eyebrow index="02">Chiptuning</Eyebrow>
        <h2 className="font-display text-5xl font-black uppercase leading-[0.9] md:text-7xl">{t.h2a}<br /><span className="stroke-text">{t.h2b}</span></h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="max-w-lg text-base leading-relaxed text-zinc-300">
          {t.p}
        </p>
        <Link to="/chiptuning" data-testid="tuning-page-link" className="mt-5 inline-flex items-center gap-2 text-sm text-white underline decoration-[var(--red)] underline-offset-4 hover:text-zinc-200">
          {t.more} <ArrowUpRight size={14} />
        </Link>
      </Reveal>
    </div>
    <div className="relative mx-auto max-w-7xl px-5 pb-6 sm:px-8">
      <GcfWidget />
    </div>
    <TuningServices />
  </section>
  );
};
